import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '🔒',
      title: '100% Anonymous Calls',
      description: 'Your Personal Identity Is Never Shared With Others. All Your Calls Are Completely Anonymous.',
      gradient: 'gradient-1'
    },
    {
      icon: '💚',
      title: 'Caring Community',
      description: '92% Of Hopmate Users Feel More Connected, Secure And Supported Since Joining The Platform.',
      gradient: 'gradient-2'
    },
    {
      icon: '💬',
      title: 'Meaningful Talk',
      description: '75% Of Our Users Report Forming Meaningful Connections Within Their First Week On The App.',
      gradient: 'gradient-3'
    }
  ];

  return (
    <section id="feature" className="features-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Conversational Therapy Services for Everyone
          </h2>
          <p className="section-description">
            Your language, your city, your convenience - Hopmate brings therapy services to every corner of India
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="feature-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`feature-icon ${feature.gradient}`}>
                <span className="icon-emoji">{feature.icon}</span>
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

